/*eslint no-alert:0 */
define('common/baseRouter',['require','glu/router','./views/login/top'],function(require) {
	'use strict';
	var Router = require('glu/router'),
		Login = require('./views/login/top');

	return Router.extend({
		routes: {
			// Empty function for 'router:reload'
			'redirecting': function() {},
			'login': function() {
				this.appBus.trigger('http:401');
				this.appBus.trigger('show:page', new Login());
			},
			'*404': function() {
				window.alert('404');
			}
		}
	});
});

